module.exports = __webpack_public_path__ + "static/media/women-faq.fc95d48b.svg";